export const STATUS_STRINGS = {
    AGENT_PANEL: "Agent Panel",
    AGENT: "Agent",
    STATUS: "Status",
    PROFILE: "Profile",
    HISTORY: "History",
    AGENT_AVAILABILITY: "Agent Availability",
    AVAILABLE: "Available",
    OFFLINE: "Offline",
    ONLINE: "Online",
    SAVE: "Save",
    REASON: "Reason",
    EXPIRED: "Expired",
    REFRESH: "Refresh",
    ACS_IDENTITY: "ACS Identity",
    ACS_IDENTITY_STATUS : "ACS Identity Status",
    WORKER_ID: "Worker ID",
    AGENT_GUID: "Agent GUID",
};

export const STATUS_TABS = {
    PROFILE: "Profile",
    HISTORY: "History",
    NOTES: "Notes",
    CALLS: "Calls",
    CHATS: "Chats",
    TEXTS: "Texts",
    EMAILS: "Emails"
};

export const PROFILE_TABLE_COLUMNS = [
    { id: "firstname", isSortable: false, label: "First Name" },
    { id: "lastname", isSortable: false, label: "Last Name" },
    { id: "email", isSortable: false, label: "Email" },
    { id: "role", isSortable: false, label: "Role" },
    { id: "extension", isSortable: false, label: "Extension" },
];

export const PROFILE_TABLE_COLUMN_KEYS = {
    FIRSTNAME: "firstname",
    LASTNAME: "lastname",
    EMAIL: "email",
    ROLE: "role ",
    EXTENSION: "extension",
};

export const HISTORY_TABLE_COLUMNS = [
    { id: "status", isSortable: false, label: "Status" },
    { id: "skills", isSortable: false, label: "Skills" },
    { id: "reason", isSortable: false, label: "Reason" },
    { id: "time", isSortable: false, label: "Time" },
];

export const HISTORY_TABLE_COLUMN_KEYS = {
    STATUS: "status",
    SKILLS: "skills",
    REASON: "reason",
    TIME: "time",
};

export const NOTES_TABLE_COLUMNS = [
    { id: "firstname", isSortable: false, label: "First Name" },
    { id: "lastname", isSortable: false, label: "Last Name" },
    { id: "note", isSortable: false, label: "Note" },
    { id: "date", isSortable: false, label: "Date" },
];

export const NOTES_TABLE_COLUMNS_KEYS = {
    FIRSTNAME: "firstname",
    LASTNAME: "lastname",
    NOTE: "note",
    DATE: "date",
};

export const CALLS_TABLE_COLUMNS = [
    { id: "firstname", isSortable: false, label: "First Name" },
    { id: "lastname", isSortable: false, label: "Last Name" },
    { id: "phonenumber", isSortable: false, label: "Phone Number" },
    { id: "date", isSortable: false, label: "Date" },
];

export const CALLS_TABLE_COLUMNS_KEYS = {
    FIRSTNAME: "firstname",
    LASTNAME: "lastname",
    PHONENUMBER: "phonenumber",
    DATE: "date",
};

export const CHATS_TABLE_COLUMNS = [
    { id: "firstname", isSortable: false, label: "First Name" },
    { id: "lastname", isSortable: false, label: "Last Name" },
    { id: "userresponse ", isSortable: false, label: "Customer" },
    { id: "cararesponse", isSortable: false, label: "Response" },
    { id: "userresponsetime", isSortable: false, label: "Date" },
    { id: "cararesponsetime", isSortable: false, label: "Response Date" },
];

export const CHATS_TABLE_COLUMNS_KEYS = {
    FIRSTNAME: "firstname",
    LASTNAME: "lastname",
    CUSTOMER_RESPONSE: "userresponse",
    CARA_RESPONSE: "cararesponse",
    CUSTOMER_RESPONSE_DATE: "userresponsetime",
    CARA_RESPONSE_DATE: "cararesponsetime",
};

export const TEXTS_TABLE_COLUMNS = [
    { id: "firstname", isSortable: false, label: "First Name" },
    { id: "lastname", isSortable: false, label: "Last Name" },
    { id: "customer", isSortable: false, label: "Customer" },
    { id: "response", isSortable: false, label: "Response" },
    { id: "date", isSortable: false, label: "Date" },
    { id: "responsedate", isSortable: false, label: "Response Date" },
];

export const TEXTS_TABLE_COLUMNS_KEYS = {
    FIRSTNAME: "firstname",
    LASTNAME: "lastname",
    CUSTOMER: "customer",
    RESPONSE: "response",
    DATE: "date",
    RESPONSEDATE: "responsedate",
};

export const EMAILS_TABLE_COLUMNS = [
    { id: "firstname", isSortable: false, label: "First Name" },
    { id: "lastname", isSortable: false, label: "Last Name" },
    { id: "customer", isSortable: false, label: "Customer" },
    { id: "response", isSortable: false, label: "Response" },
    { id: "date", isSortable: false, label: "Date" },
    { id: "responsedate", isSortable: false, label: "Response Date" },
];

export const EMAILS_TABLE_COLUMNS_KEYS = {
    FIRSTNAME: "firstname",
    LASTNAME: "lastname",
    CUSTOMER: "customer",
    RESPONSE: "response",
    DATE: "date",
    RESPONSEDATE: "responsedate",
};

export const STATUS_MESSAGES = {
    AGENT_AVAILABILITY_SUCCESS: "Availability and skills saved successfully.",
    AGENT_OFFLINE_SUCCESS: "Offline reason saved successfully.",
}
export const STATUS_ERRORS = {
    NO_USER_FOUND: "No user found for email:",
    FETCH_AGENT_ERROR: "Error fetching Agent name:",
    FETCH_ACTIVE_SKILLS_ERROR: "Error fetching Active Skills",
    FETCH_ACTIVE_REASONS_ERROR: "Error fetching Active Reasons",
    SAVE_AVAILABLE_STATUS_ERROR: "Error saving Available Status",
    SAVE_OFFLINE_STATUS_ERROR: "Error saving Offline Status",
    FETCH_AGENT_ACTIVE_SKILLS_ERROR: "Error fetching agent's active skills.",
    FETCH_AGENT_OFFLINE_REASON_ERROR: "Error fetching agent offline reason",
    FETCH_AGENT_STATUS_ERROR: "Error fetching agent current status",
    FETCH_AGENT_STATUS_HISTORY_ERROR: "Error fetching agent status history"
};